import React from 'react'
import lazyLoad from '@utils/lazyLoad'
const applicationCode = 'fe215caa-efeb-4646-836a-92cd3904f3d7'
const marketingRoutes = [
  {
    path: '/marketing/customerGroup',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/CustomerGroup')
    ),
    meta: {
      applicationCode,
      title: '客群分组'
    }
  },
  {
    path: '/marketing/customerGroup/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/CustomerGroup/detail')
    ),
    meta: {
      applicationCode,
      title: '客群详情'
    }
  },
  {
    path: '/marketing/activity/initiativeMarketing',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/Activity/InitiativeMarketing')
    ),
    meta: {
      applicationCode,
      title: '主动营销'
    }
  },
  {
    path: '/marketing/activity/initiativeMarketing/detail/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/Activity/InitiativeMarketing/detail')
    ),
    meta: {
      applicationCode,
      title: '主动营销详情'
    }
  },
  {
    path: '/marketing/activity/initiativeMarketing/detail/flow/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/Activity/InitiativeMarketing/flow')
    ),
    meta: {
      applicationCode,
      title: '主动营销编辑流程',
      hideCrumb: true
    }
  },
  {
    path: '/marketing/activity/eventsCampaign',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/Activity/EventsMarketing')
    ),
    meta: {
      applicationCode,
      title: '事件营销'
    }
  },
  {
    path: '/marketing/activity/eventsCampaign/detail/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/Activity/EventsMarketing/detail')
    ),
    meta: {
      applicationCode,
      title: '事件营销详情'
    }
  },
  {
    path: '/marketing/activity/eventsCampaign/detail/flow/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/Activity/EventsMarketing/flow')
    ),
    meta: {
      applicationCode,
      title: '事件营销编辑流程',
      hideCrumb: true
    }
  }
]

export default marketingRoutes
